export default "__VITE_ASSET__85dc0eb0__"